import locales from 'src/i18n/locales/en.json';

export const MIN_VALID_AGE = 17;

export const defaultMonthOption = {
    value: locales.dropdown_default_option_month,
    label: 'dropdown_default_option_month',
};

export const months = [
    { value: locales.months_january, label: 'months_january' },
    { value: locales.months_february, label: 'months_february' },
    { value: locales.months_march, label: 'months_march' },
    { value: locales.months_april, label: 'months_april' },
    { value: locales.months_may, label: 'months_may' },
    { value: locales.months_june, label: 'months_june' },
    { value: locales.months_july, label: 'months_july' },
    { value: locales.months_august, label: 'months_august' },
    { value: locales.months_september, label: 'months_september' },
    { value: locales.months_october, label: 'months_october' },
    { value: locales.months_november, label: 'months_november' },
    { value: locales.months_december, label: 'months_december' },
];
